import { Routes } from 'constants/routes';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useDebounce } from 'usehooks-ts';
import { syncShallowSearchUrl } from 'utils/search-query';
import styles from './styles.module.css';

import { Icon } from 'common/icon';
import Link from 'next/link';
import { ResultSearch } from '../search-items-table';

export const SearchComponent = () => {
  const router = useRouter();
  const search = router.query.q
    ? String(decodeURIComponent(router.query.q?.toString()))
    : router.query.q3
      ? String(decodeURIComponent(router.query.q3?.toString()))
      : '';
  const searchRef = useRef<HTMLInputElement | null>(null);
  const [filter, setFilter] = useState('');

  const debounceValue = useDebounce(filter, 500);

  useEffect(() => {
    if (search) {
      setFilter(search);
      searchRef.current?.focus();
    }
  }, [search]);

  useEffect(() => {
    syncShallowSearchUrl(router, Routes.search, debounceValue, 'q3');
  }, [debounceValue, router]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.text}>
            <span className={styles.highlight}>
              {
                '9 out of 10 online casinos reduce the RTP so that the player cannot win. '
              }
            </span>
            <span className={styles.accentText}>{'RTPCheck.com'}</span>
            <div className={styles.highlight}>
              {
                'The first casino rating with RTP games data, check the RTP before each game.'
              }
            </div>
          </div>
          <div className={styles.checkContainer}>
            <Link href={Routes.search} className={styles.icon}>
              <Icon.Search color={'black'} width="29px" height="29px" />
            </Link>
            <input
              type="text"
              value={filter}
              ref={searchRef}
              className={styles.searchInput}
              onChange={(e) => setFilter(e.target.value)}
              placeholder={'Check out the RTP online casino.'}
            />
            {(filter.length || search?.length) && (
              <button
                onClick={() => {
                  setFilter('');
                  searchRef.current?.focus();
                }}
                className={styles.clearContainer}
              >
                <Icon.Close height={20} width={20} />
                <span>{'Clear'}</span>
              </button>
            )}
          </div>
        </div>
      </div>
      <ResultSearch searchText={debounceValue} />
    </>
  );
};
